// eslint-disable-next-line import/no-cycle
import { Property } from '@/types';
// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '../utils/helpers';

// IIFE wrapper pattern
const IIFE_START = '(function () {\n';
const IIFE_END = '\n})();';

/**
 * Set JavaScript content in script tag, wrapping it in an IIFE
 */
const setJavascriptContent = (selector: string, property: Property): void => {
  const template = getTemplateIframeDocument();
  const scriptElement: HTMLScriptElement | null = template?.querySelector(selector);

  if (scriptElement && property.value !== undefined) {
    const wrappedContent = `${IIFE_START}${property.value}${IIFE_END}`;
    scriptElement.textContent = wrappedContent;
  }
};

export default setJavascriptContent;
